module.exports = __webpack_public_path__ + "img/启用禁用.93dcaceb.svg";